import { Seo } from "../lib/seo";

export const Standard = () => (
  <>
    <Seo
      title="The open standard"
      description="Bancony stewards bank2ai, an open specification for connecting banking systems to AI agents. Open, auditable, vendor-independent."
      path="/standard"
    />

    <section className="page-hero">
      <div className="page-hero-inner">
        <span className="section-eyebrow">The standard</span>
        <h1>An open standard for AI in banking.</h1>
        <p className="page-hero-sub">
          Bancony's products run on{" "}
          <a href="https://bank2ai.com" target="_blank" rel="noopener noreferrer" className="bank2ai-link" style={{ color: "var(--accent)" }}>bank2ai</a>,
          an open specification that defines how banking systems expose
          capabilities to AI agents. Bancony stewards the spec, runs the drift tests,
          and ships the reference adapters under Apache 2.0.
        </p>
      </div>
    </section>

    <section className="section">
      <div className="section-inner" style={{ maxWidth: 760 }}>
        <h2>Why an open banking-specific layer?</h2>
        <p>
          Banking has always converged on open standards: BIAN for capability
          terminology, ISO 20022 for payments messaging, FAPI for API security. The
          arrival of AI agents needed the same treatment: a banking-specific layer that
          names the primitives, defines the security model, and lets multiple vendors
          compete on implementation while the schemas stay shared.
          
          &nbsp;<a href="https://bank2ai.com" target="_blank" rel="noopener noreferrer" className="bank2ai-link">bank2ai</a> is that layer.
        </p>

        <h2 style={{ marginTop: 56 }}>Bancony's role as steward.</h2>
        <p>
          Our team contributes to and maintains the open spec. Our commercial products,
          Bancony Server and Bancony Assistant, implement the spec faithfully and pass
          the same drift tests as the reference implementation. We don't fork.
          We don't extend privately. The schemas you write against today are the schemas
          another implementation will run against tomorrow.
        </p>

        <h2 style={{ marginTop: 56 }}>The anti-lock-in commitment.</h2>
        <p>
          We commit, in writing in the Bancony Server contract, that a bank can migrate
          from Bancony Server to another bank2ai implementation with no handler rewrite.
          Schemas, contracts, and bank-specific adapters move with you. If you ever want
          to go back to the open library, you can do that too. It is the same protocol.
        </p>

        <p style={{ marginTop: 48 }}>
          <a href="https://bank2ai.com/docs/specification/overview" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Read the spec on bank2ai.com</a>
        </p>
      </div>
    </section>
  </>
);
